import {BaseService, GET, Headers, Query, Response} from 'ts-retrofit';
import {ACCEPT_JSON} from '../config';

const base = 'tools';

export class ToolsApiService extends BaseService {

    @GET(`/${base}/randomText`)
    @Headers({...ACCEPT_JSON})
    async getRandomText(@Query('length') length: number | null = null): Promise<Response<string>> {
        return <Response>{};
    }
}
